import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Debug: Log the actual URL being used
    const fullUrl = config.baseURL + config.url;
    console.log('🔍 Axios Request URL:', fullUrl);
    console.log('🔍 Axios Base URL:', config.baseURL);
    console.log('🔍 Axios URL:', config.url);
    
    // Force HTTPS in the actual request
    if (fullUrl.startsWith('http://')) {
      const httpsUrl = fullUrl.replace('http://', 'https://');
      console.warn('🚨 FORCING HTTPS in axios request:', fullUrl, '→', httpsUrl);
      config.url = httpsUrl;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid, redirect to login
      localStorage.clear();
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api; 